import { filterBuilder, FilterBuilderParams } from '@ha/algolia';
import { LISTINGS_PER_CITY_FILTER } from 'ha/pages/UserPage/constants';

const queryFilterBuilder = filterBuilder();

const makeAlgoliaQuery = ({
  advertiserId,
  city,
  country,
}: FilterBuilderParams) => {
  const filters = queryFilterBuilder({ advertiserId, city, country });

  return {
    query: '',
    params: {
      distinct: true,
      attributesToHighlight: [],
      page: 0,
      hitsPerPage: LISTINGS_PER_CITY_FILTER,
      filters,
    },
  };
};
export { makeAlgoliaQuery };
